import { Stack } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { useFormikContext } from 'formik';
import { Step } from '../..';
import SingleSelect from '../../../../form/base/SingleSelect';
import ButtonsSelect from '../../../../form/base/ButtonsSelect';
import StepFlowCopy from '../../StepFlowCopy';
import TextInput from '../../../../form/base/TextInput';
import CategorySingleSelect from '../../../../form/base/CategorySingleSelect';
import TextareaInput from '../../../../form/base/TextareaInput';

interface Props {
  steps: Step[];
  step: Step;
  input: Step['inputs'][number];
  currentStep: number;
  setCurrentStep: Dispatch<SetStateAction<number>>;
  isSequential: boolean;
  submitText?: string;
}

function StepsFlowInput({ step, input }: Props) {
  const { isSubmitting, values } = useFormikContext();

  return (
    <Stack gap={2.5}>
      {input.contentType === 'text' && (
        <TextInput
          {...input}
          disabled={step.disabled || input.disabled || isSubmitting}
        />
      )}
      {input.contentType === 'textarea' && (
        <TextareaInput
          {...input}
          disabled={step.disabled || input.disabled || isSubmitting}
        />
      )}
      {input.contentType === 'select' && (
        <SingleSelect
          {...input}
          disabled={step.disabled || input.disabled || isSubmitting}
        />
      )}
      {input.contentType === 'category-select' && (
        <CategorySingleSelect
          {...input}
          autoWidth={false}
          disabled={step.disabled || input.disabled || isSubmitting}
        />
      )}
      {input.contentType === 'button-select' && (
        <ButtonsSelect
          {...input}
          disabled={step.disabled || input.disabled || isSubmitting}
        />
      )}
      {input.contentType === 'copy' && (
        <StepFlowCopy
          {...input}
          content={input.getCopyText(values)}
          instructions={input.getInstructions?.(values)}
          onCopy={input.onCopy}
        />
      )}
    </Stack>
  );
}

export default StepsFlowInput;
